import React from 'react';
import { CheckSquare } from 'lucide-react';
export function Approvals() {
  return <div data-id="element-69">
      <div className="mb-6" data-id="element-70">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-71">Approbations</h1>
        <p className="text-gray-600" data-id="element-72">
          Gérez toutes les demandes en attente d'approbation
        </p>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6" data-id="element-73">
        <div className="flex items-center justify-between mb-6" data-id="element-74">
          <h2 className="text-lg font-semibold text-gray-900" data-id="element-75">
            Toutes les demandes
          </h2>
          <CheckSquare className="h-5 w-5 text-blue-600" data-id="element-76" />
        </div>
        <div className="text-center py-12" data-id="element-77">
          <div className="mx-auto h-12 w-12 rounded-full bg-gray-100 flex items-center justify-center mb-4" data-id="element-78">
            <CheckSquare className="h-6 w-6 text-gray-400" data-id="element-79" />
          </div>
          <h3 className="text-gray-900 font-medium mb-1" data-id="element-80">
            Fonctionnalité en développement
          </h3>
          <p className="text-gray-500" data-id="element-81">
            La gestion des approbations sera bientôt disponible
          </p>
        </div>
      </div>
    </div>;
}